package com.milta.core.localization.translations.fr

import com.milta.core.localization.SubscriptionStrings

internal val Subscription = SubscriptionStrings(
    screenTitle = "Mon abonnement",
    screenSubtitle = "Gérez votre abonnement Milta",
    planDriver = "Livreur",
    planOrganisation = "Entreprise",
    statusActive = "Actif",
    statusTrial = "Essai gratuit",
    statusExpired = "Expiré",
    statusCancelled = "Annulé",
    platformLabel = "Plateforme",
    productIdLabel = "Produit",
    expiresAtLabel = "Expire le",
    noExpiry = "Sans date d'expiration",
    noValue = "—",
    noSubscription = "Aucun abonnement actif",
    activateButton = "Activer l'abonnement",
    successActivated = "Abonnement activé avec succès",
    perMonth = "/mois",
    pitchTitle = "Débloquez toutes les fonctionnalités Milta",
    pitchSubtitle = "Choisissez l'offre adaptée à votre activité pour continuer à livrer et gérer vos tournées.",
    featuredBadge = "TOUT INCLUS",
    driverFeature1 = "Tournées & livraisons illimitées",
    driverFeature2 = "Preuve de livraison photo + signature",
    driverFeature3 = "Notifications temps réel",
    orgFeature1 = "Gestion d'équipe illimitée",
    orgFeature2 = "Dashboard web complet",
    orgFeature3 = "Import tournées (Excel, PDF, photo)",
    orgFeature4 = "Accès Livreur inclus pour vous-même",
    purchaseFinePrint = "Paiement sécurisé via le store. Annulable à tout moment depuis les paramètres du store.",
    purchasingLabel = "Traitement en cours…",
    activeCaption = "Votre abonnement Milta",
    nextRenewalLabel = "Prochain renouvellement",
    includedTitle = "Inclus dans votre offre",
    manageOnGooglePlay = "Gérer sur Google Play",
    manageOnAppStore = "Gérer sur l'App Store",
    viewTechnicalDetails = "Voir les détails techniques",
    monthNames = listOf("janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"),
    errorNotFound = "Aucun abonnement actif trouvé",
    errorConflict = "Un abonnement actif existe déjà pour ce compte",
    errorPlanMismatch = "Le plan sélectionné ne correspond pas à votre rôle de compte",
    errorPlanRequired = "Veuillez sélectionner un plan",
    errorPlanInvalid = "Plan sélectionné invalide",
    errorPlatformRequired = "La plateforme est requise",
    errorPlatformInvalid = "Plateforme invalide. Doit être AppStore ou GooglePlay",
    errorStoreProductIdRequired = "L'identifiant du produit store est requis",
    errorReceiptTokenRequired = "Le token de reçu est requis",
    errorGeneric = "Une erreur s'est produite. Veuillez réessayer.",
    trialBannerDaysPrefix = "🎉 Essai gratuit : il vous reste ",
    trialBannerDaysBold = "%d jours",
    trialBannerDaysSuffix = " pour découvrir Milta sans engagement.",
    trialBannerHoursPrefix = "⏰ Votre essai gratuit se termine dans ",
    trialBannerHoursBold = "%dh",
    trialBannerHoursSuffix = " : abonnez-vous pour continuer à utiliser Milta sans interruption.",
)
